import { AbstractPmsApiService } from "./abstract.service";
import {PaymentGatewayApiLog} from "../models/payment-gateway-api-log.model";

/**
 * @abstract
 * @extends {AbstractPmsApiService<PaymentGatewayApiLog>}
 */
export class PaymentGatewayApiLogService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/payment-gateway-api-log(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {PaymentGatewayApiLog}
     * @protected
     */
    newModel(attributes, ...params) {

        return new PaymentGatewayApiLog(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<PaymentGatewayApiLog>>}
     */
    get(params = {}, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     *
     * @param {Property=} property
     * @param {PaymentGatewayApiLog=} log
     * @returns {Promise.<Boolean>}
     */
    resend(property, log) {

        const url = this.url({
            propertyId: property.id,
            id: log.id,
        });

        return this.http
            .get(url + '/resend', {
                headers: this.authHeaders,
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/payment-gateway-api-log.service.js